import _ from 'lodash'
import {
  // splitOutsideQuotes,
  validateNonEmptyString,
  getEnumValidator,
  validateInt,
  validateNumber,
  validateDateTimeString,
  validateCIDR,
  validateIPorCIDR,
  validateDomain,
  validateIP,
  validateIPv4,
  validateIPv6,
  validatePort,
  validateMacAddress,
  validateURL,
  validateHash,
} from 'pw-validators'

import {
  // getQuoteRanges,
  IDE_PART_TYPES
} from 'pw-drafty'


// NOTE order of operators matters to ensure proper matching. (e.g. >= is matched before =)
export const QUERY_OPERATORS = [
  '>=',
  '<=',
  '!=',
  // '<>', // TODO "between" operator?
  '>',
  '<',
  '='
]

export const QUERY_OPERATORS_TO_QUERY_STATE = {
  '>=': 'gte',
  '<=': 'lte',
  '!=': '!eq',
  '>': 'gt',
  '<': 'lt',
  '=': 'eq'
}

export const QUERY_OPERATOR_START_CHARS = QUERY_OPERATORS.map(o => o[0])
export const QUERY_OPERATOR_END_CHARS = QUERY_OPERATORS.map(o => o[1])

export const QUERY_OPERATOR_TOOLTIPS = {
  '>=': 'Greater than or equal to',
  '<=': 'Less than or equal to',
  '>': 'Greater than',
  '<': 'Less than',
  '!=': 'Is not',
  '=': 'Is'
}

export const QUERY_CONJUNCTIONS = {
  AND: "and",
  OR: "or"
}

export const DEFAULT_CONJUNCTION = QUERY_CONJUNCTIONS.AND

export const QUERY_PART_CONJUNCTIONS = {
  "and": QUERY_CONJUNCTIONS.AND,
  "or": QUERY_CONJUNCTIONS.OR,
  "AND": QUERY_CONJUNCTIONS.AND,
  "OR": QUERY_CONJUNCTIONS.OR,
  "&&": QUERY_CONJUNCTIONS.AND,
  "||": QUERY_CONJUNCTIONS.OR
}

export const CASE_INSENSITIVE = true // If true, typeahead and UI validation will be case-insensitive
export const VALIDATE_WITHOUT_QUOTES = true // If true, validation functions will be passed a value with enclosing quotes stripped

export const QUERY_PART_TYPES = {
  'CONJUNCTION': 'CONJUNCTION',
  'FIELD': 'FIELD',
  'VALUE': 'VALUE',
  'OPERATOR': 'OPERATOR',
  'GROUP': 'GROUP',
  'CLAUSE': 'CLAUSE'
}


export const QUERY_INPUT_TYPES = _.mapValues({
  INT: {
    validate: validateInt,
    isNumeric: true,
  },
  FLOAT: {
    validate: validateNumber,
    isNumeric: true,
  },
  DOUBLE: {
    validate: validateNumber,
    isNumeric: true,
  },
  STRING: {
    validate: validateNonEmptyString
  },
  ENUM: {
    validate: getEnumValidator('options', true, 'displayOptions')
  },
  // STRING_ARRAY: {},
  DATETIME: {
    validate: validateDateTimeString,
    isNumeric: true, // TODO?
  },
  CIDR: {
    validate: validateCIDR
  },
  IP_OR_CIDR: {
    validate: validateIPorCIDR
  },
  IP: {
    validate: validateIP
  },
  IP_V4: {
    validate: validateIPv4
  },
  IP_V6: {
    validate: validateIPv6
  },
  MAC_ADDRESS: {
    validate: validateMacAddress
  },
  DOMAIN: {
    validate: validateDomain
  },
  URL: {
    validate: validateURL
  },
  PORT: {
    validate: validatePort,
    isNumeric: true,
  },
  HASH: {
    validate: validateHash
  }
}, (typeDef) => {
  let _operatorOptions = [
    '=', // First (most common) option
    '!='
  ]
  if (typeDef.isNumeric) {
    _operatorOptions = _operatorOptions.concat([
      '>=',
      '<=',
      '>',
      '<'
    ])
  }
  return _.assign(typeDef, {
    operatorOptions: _operatorOptions
  })
})

// Export so owners can use built-in types in schemas
export const QUERY_INPUT_TYPE_NAMES = _.mapValues(QUERY_INPUT_TYPES, (v, typeName) => typeName)

export const QUERY_INPUT_SCHEMA_DEFAULTS =  {
  conjunction: {
    fieldName: "conjunction",
    isQueryOption: false,
    options: [
      'AND',
      'OR'
    ],
    tooltip: "Query conjunction",
    partType: IDE_PART_TYPES.VALUE,
    className: "query_conjunction"
  },
  grouping: {
    fieldName: "grouping",
    isQueryOption: false,
    partType: IDE_PART_TYPES.GROUP,
    className: "query_grouping"
  },
  unknown: {
    fieldName: "unknown",
    isQueryOption: false,
    tooltip: `Unknown Field`,
    className: 'unknown_field',
    partType: IDE_PART_TYPES.KEY_VALUE,
    type: QUERY_INPUT_TYPE_NAMES.STRING,
    children: {
      key: {
        className: 'unknown_field unknown_key',
        tooltip: `Unknown Query Field`,
      },
      operator: {
        className: 'unknown_field unknown_operator',
        tooltip: `Unknown Query Field Operator`,
      },
      value: {
        className: 'unknown_field unknown_value',
        tooltip: `Unknown Query Field Value`,
      }
    }
  }
}


// const OPERATORS = {
//   'eq': {
//     label: 'is',
//     abbr: '='
//   },
//   '!eq': {
//     label: "is not",
//     abbr: '!='
//   },
//   'gt': {
//     label: 'is more than',
//     abbr: '>'
//   },
//   'lt': {
//     label: 'is less than',
//     abbr: '<'
//   },
//   'gte': {
//     label: 'is at least',
//     abbr: '≥'
//   },
//   'lte': {
//     label: 'is at most',
//     abbr: '≤'
//   },
//   'between': {
//     label: 'is between',
//     abbr: 'between'
//   },
//   'timerange': {
//     label: 'is',
//     abbr: '='
//   }
// }
//
// const OPERATORS_BY_TYPE = {
//   string: ['eq', '!eq'],
//   deviceId: ['eq', '!eq'],
//   "enum": ['eq', '!eq'],
//   int: ['eq', '!eq', 'gt', 'lt', 'gte', 'lte', 'between'],
//   time: ['timerange']
// }
